import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

type TProps = {
  data: TRecommendation;
};

export const Description = React.memo(({ data }: TProps) => {
  return (
    <div className="vitrine-template1__description">{data.description}</div>
  );
});
